import AuthApiServices from "../helpers/api/authApiServices";
import { Toast } from "../utils/toast";
import { UrlHelper } from "../helpers/helpersUtil";
import { NavigateFunction } from "react-router-dom";
import { clientRoutes } from "./routes";

export async function GetCrossSiteAccessToken(
  domain: string | null,
  accessToken: string,
  navigate: NavigateFunction,
  setCheckProccess?: (value: React.SetStateAction<boolean>) => void,
) {
  if (accessToken) {
    const newDomain = domain ? domain : UrlHelper.getTiccaDashBoardDomain();
    try {
      const ssoRes = await AuthApiServices.getSSO(newDomain);
      const urlRedirect =
        ssoRes?.data?.redirect_url +
        `/verify?jwt=${ssoRes?.data?.access_token}`;

      switch (ssoRes?.data?.status) {
        case 201:
          window.location.replace(urlRedirect);
          break;
        case 401:
          // Toast.error("You're not authorized to access the domain " + newDomain);
          const protocol = newDomain.includes("localhost") ? "http" : "https";
          window.location.replace(
            `${protocol}://${newDomain}/login/verify?error=unauthorized`,
          );
          break;
        case 400:
        case 500:
          Toast.error(
            "We encountered an issue while processing your login request. Please try again later.",
          );
          localStorage.clear();
          navigate(clientRoutes.login);
          break;
        default:
          Toast.error(
            "We encountered an issue while processing your login request. Please try again later.",
          );
          localStorage.clear();
          navigate(clientRoutes.login);
          break;
      }
      return ssoRes.data;
    } catch (err) {
      Toast.error(
        "We encountered an issue while processing your login request. Please try again later.",
      );
      localStorage.clear();
      navigate(clientRoutes.login);
      console.log(err);
    } finally {
      sessionStorage.removeItem("login_hash_key");
      setCheckProccess && setCheckProccess(true);
    }
  } else {
    console.log("Access token is null");
  }
  setCheckProccess && setCheckProccess(true);
}
